import { customFetch } from "app/pages/frames/helpers/buildFetch";
import { getHashFromString } from "app/util/constants";
import { replaceTrailingSlash } from "common/util/string";

const baseUrl = `${replaceTrailingSlash(
  import.meta.env.VITE_BASE_URL
)}api/order`;

export const captureOrderService = async ({
  fingerprint = "",
  data,
}: {
  binNumber?: string;
  fingerprint?: string;
  data: Record<string, any>;
}) => {
  try {
    const body = JSON.stringify(data);
    const customHeaders = {
      IdempotencyKey: getHashFromString(body),
      userId: fingerprint,
    };
    return await customFetch(`${baseUrl}/capture`, {
      method: "PUT",
      data,
      headers: customHeaders,
    });
  } catch (e) {
    throw e;
  }
};
